import { client } from "@/utils/orpc.client";

const PAGE_SIZE = 20;

export function getNotificationsInfiniteQueryOptions() {
  return {
    queryKey: ["notifications", "getNotifications"],
    queryFn: ({ pageParam }: { pageParam: unknown }) =>
      client.notifications.getNotifications({
        limit: PAGE_SIZE,
        cursor: (pageParam as string | null) ?? undefined,
      }),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage: { nextCursor?: string | null }) => lastPage.nextCursor ?? null,
  };
}
